import { render, staticRenderFns } from "./PatientFollowUp.vue?vue&type=template&id=4c2c7edd&scoped=true"
import script from "./PatientFollowUp.vue?vue&type=script&lang=js"
export * from "./PatientFollowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c7edd",
  null
  
)

export default component.exports